import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { JwtInterceptor } from '../core/interceptors/jwt.interceptor';
import { HttpErrorInterceptor } from '../core/interceptors/http-error.interceptor';
import { CancelDuplicateRequestsInterceptor } from '../core/interceptors/cancel-duplicate-requests.interceptor';
import { PendingInterceptorService, PendingInterceptorServiceFactoryProvider } from './pending-interceptor.service';

@NgModule({
  imports: [CommonModule, RouterModule],
  providers: [
    // Order matters: JWT first (adds auth headers), then cancellation (aborts older duplicates), then error handler, then loading counter.
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CancelDuplicateRequestsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useExisting: PendingInterceptorService, multi: true },
    PendingInterceptorServiceFactoryProvider,
  ],
})
export class PendingInterceptorModule {}

